export interface PagedContent<T> {
  content: T[];
  totalElements: number;
}

export interface IWaitingRoomEmployee {
  id: string;
  firstName: string;
  lastName: string;
  fk: string;
  organizationUnitName: string | null;
}

export enum WaitingRoomConditionType {
  AHR_ACCEPTANCE_REQUIRED = "AHR_ACCEPTANCE_REQUIRED",
  ACCEPT_ONLY = "ACCEPT_ONLY",
  ACTIVE_FORM = "ACTIVE_FORM",
  BARCODE = "BARCODE",
  EMPLOYEE_REQUIRED = "EMPLOYEE_REQUIRED",
  FINANCING_CHANGE_REQUIRED = "FINANCING_CHANGE_REQUIRED",
  PARENT_REQUIRED_AUTO = "PARENT_REQUIRED_AUTO",
  WAITING_FOR_PARENT = "WAITING_FOR_PARENT",
  DOCUMENT_REQUIRED = "DOCUMENT_REQUIRED",
  SIGNED_DOCUMENT_REQUIRED = "SIGNED_DOCUMENT_REQUIRED",
  NEW_PRICE = "NEW_PRICE",
}

enum WaitingRoomConditionStrategy {
  MANUAL = "MANUAL",
  AUTOMATIC = "AUTOMATIC",
}

export interface IWaitingRoomCondition {
  id: string | null;
  accepted: boolean;
  acceptedDate: string | null;
  barcodeId: string | null;
  description: string | null;
  documentUrl: string | null;
  conditionAcceptable: boolean;
  conditionStrategy: WaitingRoomConditionStrategy;
  type: WaitingRoomConditionType;
}

enum WaitingRoomStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  WAITING_FOR_GROUP = "WAITING_FOR_GROUP",
  CANCELLED = "CANCELLED",
}

export interface IWaitingRoom {
  id: string;
  parentWaitingRoomId?: string | null;
  beneficiaryFirstName: string | null;
  beneficiaryLastName: string | null;
  beneficiaryType: string;
  barcodeId: string | null;
  cancellable: boolean;
  conditions: IWaitingRoomCondition[];
  createdAt: string;
  documentUrl: string | null;
  name: string;
  paidByEmployee: string | null;
  status: WaitingRoomStatus;
  totalCost: string | null;
}

export interface IWaitingRoomsGroup {
  groupId: string;
  documentActive: boolean;
  documentUrl: {
    en?: string | null;
    pl: string;
  } | null;
  salaryDeductionAccepted: boolean;
  waitingRooms: IWaitingRoom[];
}

export interface IWaitingRoomsDocument {
  documentId: string;
  documentActive: boolean;
  documentUrl: {
    en?: string | null;
    pl: string;
  } | null;
  salaryDeductionAccepted: boolean;
}

export interface IGroupedWaitingRoom {
  benefitsCount: number;
  date: string;
  employee: IWaitingRoomEmployee;
  singleWaitingRooms: IWaitingRoom[];
  waitingRoomsGroup: null | IWaitingRoomsGroup;
}

export interface IMassActionsPayload {
  documents: IWaitingRoomsGroup["groupId"][];
  waitingRooms: {
    waitingRoomId: IWaitingRoom["id"];
    conditionIds: IWaitingRoomCondition["id"][];
  }[];
}

export type FilterModel = Record<string, string | Date | null | undefined>;

export interface FilterFormSchema {
  employee?: { value: string; label: string } | null;
  benefitName?: string | null;
  organizationUnitId?: string | null;
  date?: [Date | null, Date | null];
  conditionType?: string | string[];
  barcodeIds?: string[];
}

export interface ConditionTypeConfig {
  label: string;
  acceptedLabel: string;
}
